<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="4">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <CInput
                    placeholder="Username"
                    autocomplete="username email"
                    v-model="email"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    v-model="password"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton color="primary" class="px-4" @click="login"
                        >Login</CButton
                      >
                    </CCol>
                    <!-- <CCol col="6" class="text-right">
                      <CButton color="link" class="px-0"
                        >Forgot password?</CButton
                      >
                      <CButton color="link" class="d-lg-none"
                        >Register now!</CButton
                      >
                    </CCol> -->
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <!-- <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>Sign up</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <CButton
                  color="light"
                  variant="outline"
                  size="lg"
                  @click="register"
                >
                  Register Now!
                </CButton>
              </CCardBody>
            </CCard> -->
          </CCardGroup>
        </CCol>
      </CRow>
    
      <CModal
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
        :title="modalTitle"
        size="sm"
      >
         {{ errorMessage }}
        <template #header>
        
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="success">OK</CButton>
        </template>
      </CModal>
    </CContainer>
  </div>
</template>

<script>
import firebase from "firebase";
import "firebase/auth";
import "firebase/firestore";

export default {
  name: "Login",
  data() {
    return {
      firstName: "John",
      lastName: "Doe",
      email: "",
      password: "",
      myModal: false,
      modalTitle: "",
      errorMessage: "",
      
    };
  },
  created: function () {
    // `this` points to the vm instance
    if(this.$store.state.user != null)
    {
      this.$router.push("/users");
    }
  },
  methods: {
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then((userCredential) => {
          // Signed in
          var user = userCredential.user;
          //console.log('user', user);
          this.$store.state.user = user;
          //console.log(this.$store.state.user);
          this.$router.push("/dashboard");
        })
        .catch((error) => {
          var errorCode = error.code;
          console.log('errorCode', errorCode);
          this.modalTitle = "Warning!";
          this.errorMessage = error.message;
          this.myModal = true;
        });
    },
    register() {
      this.$router.push("/register");
    },
  },
};
</script>
